import React from 'react';
export const Skeleton = () => {
    return React.createElement("div", null);
};
